export const TEXT = "TEXT"
export const PHOTO = "PHOTO"
export const FILE = "FILE"
